// action constants
import Vue from 'vue'
import { StoreMutations } from './mutations';
import SwiftSpaceRepository from '../../../../api/SwiftSpaceRepository';
import {StoreState} from "@/components/swiftspace/wallpaperSearch/store/state";

export const StoreActions = {
    search: 'search',
    update: 'update',
    clearState:'clearState'
};

export const actions = {
    [StoreActions.search](context) {
        SwiftSpaceRepository.searchWallpapers()
        .then((data) => {
            context.commit(StoreMutations.SET_RESULTS, data.wallpapers)
        })
        .catch((err) => {
            Vue.prototype.$notify({'type':'danger','content':err})
        });
    },
    [StoreActions.update](context, data) {
        SwiftSpaceRepository.updateWallpaper(data.id, data)
            .then(() => {
                const wallpapers = context.state[StoreState.results].filter(it => {
                    return it.id !== data.id
                })
                context.commit(StoreMutations.SET_RESULTS, wallpapers);
            })
            .catch((err) => {
                Vue.prototype.$notify({'type':'danger','content':err})
            });
    },
    clearState(context) {
        context.commit(StoreMutations.SET_RESULTS,[]);
        context.commit(StoreMutations.SET_PAGE,0);
    }
};
